import React from 'react';
import styles from './StepsProgress.module.css';
import Step from './Step/Step';

export default props => {
  const { activeStep, steps, customThemeBaseColor } = props;

  const getStatus = index => {
    if (parseInt(activeStep, 10) === index) {
      return 'active';
    }
    if (index < parseInt(activeStep, 10)) {
      return 'completed';
    }
    return null;
  };

  return (
    <div className={styles.stepsProgressContainer}>
      <div className={styles.progressLineContainer}>
        <div
          className={styles.progressLine}
          style={{
            borderTop: customThemeBaseColor
              ? `3px dashed ${customThemeBaseColor}`
              : '3px dashed #4926e9'
          }}
        >
          <div
            className={styles.leftLine}
            style={{
              borderTop: customThemeBaseColor
                ? `3px dashed ${customThemeBaseColor}`
                : '3px dashed #4926e9'
            }}
          />
          <div
            style={{
              width: `calc(${100 -
                ((parseInt(activeStep, 10) + 1) / (steps.length - 1)) * 100}%)`
            }}
            className={styles.progressLineBackground}
          />
          <div
            className={`${styles.rightLine} ${
              parseInt(activeStep, 10) === steps.length - 1
                ? styles.rightLineCompleted
                : ''
            }`}
            style={{
              borderTop: customThemeBaseColor
                ? `3px dashed ${customThemeBaseColor}50`
                : '3px dashed #c8bdf8'
            }}
          />
        </div>
      </div>
      <div className={styles.steps}>
        {steps.map((step, index) => (
          <Step
            key={`steps-progress-step-${index.toString()}`}
            step={step}
            status={getStatus(index)}
            customThemeBaseColor={customThemeBaseColor}
          />
        ))}
      </div>
    </div>
  );
};
